import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { QuestionIcon } from '@/icons';

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('14', '24', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;

export const StyledQuestionIcon = styled(QuestionIcon)`
  margin-left: 0.5rem;
  ${pickThemeFontStyles('24', '24', 'NORMAL')};
  transform: scale(0.8);
`;

export const StyledText = styled.div`
  ${pickThemeFontStyles('14', '24', 'NORMAL')};
  color: ${COLORS.BLACK};
  margin-top: 0.5rem;
  white-space: break-spaces;
`;
